import { compose } from 'recompose';
import PFDSalesTarget from './PFDSalesTarget';
import { query } from './API';
import withRequestTracker from '../../../utils/composition/withRequestTracker';

const composedPfdSalesTarget = compose(withRequestTracker({ query }))(PFDSalesTarget);

export default composedPfdSalesTarget;
